function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Meta = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12.9123 8.87695C12.9013 8.87695 12.8903 8.87695 12.8793 8.87695L12.8353 12.4914C12.8463 12.4914 12.8573 12.4914 12.8628 12.4914C15.245 12.4914 17.0934 14.3674 21.115 21.1232L21.3625 21.5357L21.379 21.5632L23.629 18.1963L23.6125 18.1688C23.0845 17.3107 22.5729 16.5184 22.0887 15.7977C21.522 14.9615 20.9829 14.2133 20.4549 13.5477C17.7975 10.1643 15.5695 8.87695 12.9123 8.87695Z",
    fill: "url(#paint0_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.8794 8.87595C10.2057 8.88695 7.84561 10.6144 6.13466 13.2551C6.12916 13.2606 6.12366 13.2716 6.11816 13.2771L9.24846 14.977C9.25396 14.9715 9.25946 14.9605 9.26498 14.955C10.2607 13.4586 11.504 12.5014 12.8299 12.4849C12.8409 12.4849 12.8519 12.4849 12.8574 12.4849L12.9014 8.87045C12.9014 8.87595 12.8904 8.87595 12.8794 8.87595Z",
    fill: "url(#paint1_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6.13927 13.2552C6.13376 13.2607 6.12826 13.2717 6.12276 13.2772C5.00047 15.0212 4.16426 17.1557 3.71314 19.4663C3.71314 19.4773 3.70764 19.4883 3.70764 19.4938L7.22854 20.3245C7.22854 20.3135 7.23406 20.3025 7.23406 20.297C7.60814 18.267 8.32882 16.391 9.25857 14.9827C9.26407 14.9772 9.26958 14.9662 9.27507 14.9607L6.13927 13.2552Z",
    fill: "url(#paint2_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.23387 20.2968L3.71297 19.4662C3.71297 19.4772 3.70747 19.4882 3.70747 19.4937C3.45991 20.7645 3.33337 22.0518 3.33337 23.3447C3.33337 23.3557 3.33337 23.3667 3.33337 23.3777L6.94231 23.7022C6.94231 23.6912 6.94231 23.6802 6.94231 23.6692C6.94231 23.5922 6.94231 23.5207 6.94231 23.4437C6.94231 22.3983 7.04132 21.3532 7.22837 20.3298C7.22837 20.3133 7.22837 20.3078 7.23387 20.2968Z",
    fill: "url(#paint3_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.05266 24.823C6.98664 24.4488 6.95362 24.0748 6.94262 23.7007C6.94262 23.6897 6.94262 23.6787 6.94262 23.6677L3.33369 23.3432C3.33369 23.3542 3.33369 23.3652 3.33369 23.3762C3.32819 24.1298 3.39421 24.8835 3.53174 25.6317C3.53174 25.6427 3.53724 25.6537 3.53724 25.6592L7.05816 24.8505C7.05266 24.845 7.05266 24.834 7.05266 24.823Z",
    fill: "url(#paint4_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.87248 26.6925C7.48188 26.2633 7.20131 25.6472 7.05828 24.855C7.05828 24.844 7.05278 24.833 7.05278 24.8275L3.53186 25.6362C3.53186 25.6472 3.53736 25.6582 3.53736 25.6637C3.80143 27.061 4.32406 28.2218 5.07226 29.102C5.07776 29.1075 5.08326 29.1185 5.09426 29.124L7.89449 26.7145C7.88899 26.709 7.88348 26.698 7.87248 26.6925Z",
    fill: "url(#paint5_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.3035 16.6862C16.18 19.9375 14.8982 21.973 14.8982 21.973C12.0704 26.3962 11.0967 27.3865 9.52326 27.3865C8.86859 27.3865 8.31846 27.1553 7.90034 26.7043C7.89484 26.6988 7.88384 26.6878 7.87834 26.6823L5.07812 29.0918C5.08362 29.0973 5.08913 29.1083 5.10013 29.1138C6.13439 30.3132 7.58676 30.9788 9.39122 30.9788C12.1199 30.9788 14.0784 29.697 17.5663 23.6125C17.5663 23.6125 19.0187 21.0488 20.02 19.2828C19.3873 18.2982 18.8262 17.4343 18.3035 16.6862Z",
    fill: "#0082FB"
  }), /*#__PURE__*/_jsx("path", {
    d: "M22.0881 11.5625C22.0826 11.568 22.0716 11.579 22.0661 11.5845C21.4939 12.2062 20.9547 12.8608 20.4542 13.543C20.9767 14.2087 21.5214 14.9569 22.0881 15.7986C22.7537 14.7698 23.3754 13.9391 23.9861 13.3009C23.9916 13.2954 24.0026 13.2845 24.0081 13.279L22.0881 11.5625Z",
    fill: "url(#paint6_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M32.3877 11.2426C30.9078 9.75169 29.1418 8.87695 27.2603 8.87695C25.2743 8.87695 23.5965 9.96624 22.089 11.5617C22.0835 11.5672 22.0725 11.5782 22.067 11.5837L23.987 13.2946C23.9925 13.2891 24.0035 13.2781 24.009 13.2726C25.0049 12.2383 25.9675 11.7267 27.0293 11.7267C28.1792 11.7267 29.2518 12.2658 30.1817 13.2121C30.1872 13.2176 30.1982 13.2286 30.2037 13.2341L32.4097 11.2646C32.4042 11.2591 32.3932 11.2536 32.3877 11.2426Z",
    fill: "#0082FB"
  }), /*#__PURE__*/_jsx("path", {
    d: "M36.6619 22.8702C36.5794 18.0785 34.9015 13.7929 32.4038 11.2622C32.3983 11.2567 32.3873 11.2457 32.3818 11.2402L30.1758 13.2098C30.1813 13.2153 30.1923 13.2263 30.1978 13.2318C32.0738 15.1573 33.3611 18.7332 33.4766 22.8702C33.4766 22.8812 33.4766 22.8922 33.4766 22.9032H36.6619C36.6674 22.8922 36.6619 22.8812 36.6619 22.8702Z",
    fill: "url(#paint7_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M36.667 22.9042C36.667 22.8932 36.667 22.8822 36.667 22.8712H33.4817C33.4817 22.8822 33.4817 22.8932 33.4817 22.9042C33.4872 23.0967 33.4872 23.2947 33.4872 23.4873C33.4872 24.615 33.3165 25.5283 32.9755 26.183C32.97 26.194 32.9645 26.205 32.959 26.2105L35.3301 28.6752C35.3356 28.6642 35.3412 28.6587 35.3467 28.6477C36.2103 27.3217 36.6615 25.4788 36.6615 23.2397C36.667 23.1297 36.667 23.0142 36.667 22.9042Z",
    fill: "url(#paint8_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M32.9758 26.1848C32.9703 26.1958 32.9648 26.2068 32.9593 26.2123C32.6622 26.768 32.2387 27.1367 31.683 27.2962L32.7666 30.7015C32.9098 30.652 33.0473 30.597 33.1848 30.5365C33.2233 30.52 33.2673 30.498 33.3058 30.4815C33.3278 30.4705 33.3498 30.4595 33.3718 30.4485C34.0925 30.0853 34.7142 29.5518 35.1818 28.8917C35.2093 28.8475 35.2423 28.809 35.2698 28.765C35.2918 28.7375 35.3083 28.7045 35.3303 28.677C35.3358 28.666 35.3413 28.6605 35.3468 28.6495L32.9758 26.1848Z",
    fill: "url(#paint9_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M31.0013 27.3963C30.6602 27.4018 30.3192 27.3358 30.0055 27.2038L28.8997 30.6917C29.5213 30.9062 30.187 30.9998 30.9298 30.9998C31.568 31.0053 32.2007 30.9062 32.8057 30.7027L31.722 27.2973C31.4853 27.3633 31.2433 27.3963 31.0013 27.3963Z",
    fill: "url(#paint10_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M28.7833 26.2003C28.7778 26.1948 28.7723 26.1838 28.7613 26.1783L26.2141 28.8245C26.2196 28.83 26.2306 28.841 26.2361 28.8465C27.1219 29.7873 27.9691 30.376 28.9263 30.695L30.0321 27.2127C29.6304 27.0367 29.2344 26.723 28.7833 26.2003Z",
    fill: "url(#paint11_linear_17500_13523)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M28.7624 26.1797C27.9977 25.2938 27.0514 23.814 25.566 21.4263L23.624 18.1915L23.6075 18.164L21.3575 21.531L21.374 21.5585L22.7494 23.8635C24.0807 26.0862 25.1644 27.698 26.2152 28.8203C26.2207 28.8258 26.2317 28.8368 26.2372 28.8423L28.7844 26.1962C28.7789 26.1962 28.7679 26.1852 28.7624 26.1797Z",
    fill: "url(#paint12_linear_17500_13523)"
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_17500_13523",
      x1: "22.1204",
      y1: "20.1998",
      x2: "14.668",
      y2: "10.4192",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.0006",
        stopColor: "#0867DF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.4539",
        stopColor: "#0668E1"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.8591",
        stopColor: "#0064E0"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_17500_13523",
      x1: "7.59765",
      y1: "13.8671",
      x2: "12.711",
      y2: "9.97899",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.1323",
        stopColor: "#0064DF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9988",
        stopColor: "#0064E0"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_17500_13523",
      x1: "5.42474",
      y1: "19.5573",
      x2: "7.47274",
      y2: "14.3939",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.0147",
        stopColor: "#0072EC"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.6881",
        stopColor: "#0064DF"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint3_linear_17500_13523",
      x1: "5.14474",
      y1: "23.2852",
      x2: "5.38161",
      y2: "20.133",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.0731",
        stopColor: "#007CF6"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9943",
        stopColor: "#0072EC"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint4_linear_17500_13523",
      x1: "5.27551",
      y1: "24.9957",
      x2: "5.10607",
      y2: "23.7327",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.0731",
        stopColor: "#007FF9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#007CF6"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint5_linear_17500_13523",
      x1: "5.17671",
      y1: "25.3313",
      x2: "6.23319",
      y2: "27.5757",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.0731",
        stopColor: "#007FF9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#0082FB"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint6_linear_17500_13523",
      x1: "21.4569",
      y1: "14.4788",
      x2: "22.8544",
      y2: "12.543",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.2799",
        stopColor: "#007FF8"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9141",
        stopColor: "#0082FB"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint7_linear_17500_13523",
      x1: "32.1053",
      y1: "11.9676",
      x2: "35.0261",
      y2: "22.7293",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#0082FB"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9995",
        stopColor: "#0081FA"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint8_linear_17500_13523",
      x1: "35.7358",
      y1: "23.1388",
      x2: "33.8867",
      y2: "26.8817",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.0619",
        stopColor: "#0081FA"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#0080F9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint9_linear_17500_13523",
      x1: "32.4123",
      y1: "28.8668",
      x2: "34.1435",
      y2: "27.6858",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#027AF3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#0080F9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint10_linear_17500_13523",
      x1: "29.6942",
      y1: "29.0975",
      x2: "32.1023",
      y2: "29.0975",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#0377EF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9994",
        stopColor: "#0279F1"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint11_linear_17500_13523",
      x1: "27.6001",
      y1: "27.77",
      x2: "29.3301",
      y2: "28.7893",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.0019",
        stopColor: "#0471E9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#0377EF"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint12_linear_17500_13523",
      x1: "22.3235",
      y1: "20.2698",
      x2: "27.859",
      y2: "27.2405",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0.2765",
        stopColor: "#0867DF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#0471E9"
      })]
    })]
  })]
}));
Meta.displayName = 'Meta';
//# sourceMappingURL=Meta.js.map